import { StyledLabel, StyledRadio, StyledInput } from './Radio.styles';
import { RadioProps } from './Radio.types';

const Radio: React.FC<RadioProps> = ({ id, label, checked, disabled, ...props }) => {
  return (
    <StyledRadio>
      <StyledInput
        type='radio'
        role='radio'
        aria-label={label}
        data-testid={`radio-input-${id}`}
        id={id}
        checked={checked}
        aria-checked={checked}
        aria-disabled={disabled ? 'true' : 'false'}
        {...props}
      />
      <svg width='20px' height='20px'>
        <circle cx='10' cy='10' r='6' />
      </svg>
      <StyledLabel htmlFor={id} disabled={disabled}>
        {label}
      </StyledLabel>
    </StyledRadio>
  );
};

export default Radio;
